/**
 * Interval selector: Monthly | Bi-Annual | Annual.
 *
 * Data-driven from the backend `/api/billing/plans` `intervals` array so
 * marketing badges (e.g. "Save 25%") come from the canonical config and
 * never drift between Landing and BillingTab.
 */
export default function IntervalToggle({ intervals = [], value, onChange, testidPrefix = "interval" }) {
  if (!Array.isArray(intervals) || intervals.length === 0) return null;
  return (
    <div
      role="tablist"
      aria-label="Billing interval"
      data-testid={`${testidPrefix}-toggle`}
      className="inline-flex items-center gap-1 p-1 rounded-full bg-slate-100 border border-slate-200"
    >
      {intervals.map((i) => {
        const active = i.id === value;
        return (
          <button
            key={i.id}
            role="tab"
            aria-selected={active}
            data-testid={`${testidPrefix}-${i.id}`}
            onClick={() => onChange(i.id)}
            className={
              "px-4 py-1.5 text-xs font-semibold rounded-full transition " +
              (active
                ? "bg-white text-slate-900 shadow-sm"
                : "text-slate-600 hover:text-slate-900")
            }
          >
            {i.label}
            {i.badge && (
              <span className="ml-2 text-[9px] font-extrabold tracking-wider text-amber-900 bg-amber-300 px-1.5 py-0.5 rounded-full uppercase">
                {i.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
